import { render } from "./AboutPageSkills.vue?vue&type=template&id=69c9a61a"
import script from "./AboutPageSkills.vue?vue&type=script&lang=js"
export * from "./AboutPageSkills.vue?vue&type=script&lang=js"

import "./AboutPageSkills.vue?vue&type=style&index=0&id=69c9a61a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__